<template>
  <div id="show-hide-field">
    <div class="show-hide-field-body" v-if="value != null && value != ''">
      <span>
        {{ isVisible ? value : formatCharacters(value) }}
      </span>
      <v-icon
        @click="isVisible = !isVisible"
        class="ml-2"
        :class="isVisible ? 'mdi mdi-eye-off' : 'mdi mdi-eye'"
      ></v-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShowHideField',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isVisible: false,
    }
  },
  methods: {
    /**
     * Retorna uma sequência de caracteres "*" com o mesmo tamanho
     * do valor informado, ocultando seu conteúdo.
     *
     * @param {String} value Valor que será mascarado.
     * @returns {String} Valor mascarado ou uma string vazia.
     */
    formatCharacters(value) {
      if (value == null || value == '') {
        return ''
      }
      return '*'.repeat(value.length)
    },
  },
}
</script>

<style lang="scss">
#show-hide-field {
  .show-hide-field-body {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}
</style>
